import { FilterListOutlined as FilterListOutlinedIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import type { FunctionComponent } from 'react';

type FilterDrawerTriggerProps = {
    readonly hasActiveFilters: boolean;
    readonly onClick?: VoidFunction;
};

export const FilterDrawerTrigger: FunctionComponent<FilterDrawerTriggerProps> = (properties) => {
    const { hasActiveFilters, onClick } = properties;

    return (
        <IconButton
            aria-label="Open filters"
            sx={{
                minWidth: 'revert',
                px: 1,
            }}
            onClick={onClick}
        >
            <FilterListOutlinedIcon color={hasActiveFilters ? 'primary' : 'secondary'} />
        </IconButton>
    );
};
